import React, { useState, useEffect, useRef } from 'react';
import './PreparadoIngredientesModal.css';
import FormModal from '../common/FormModal';
import Select from 'react-select';
import { FaPlus, FaTrashAlt, FaSave } from 'react-icons/fa';
import { useToast } from '../../contexts/ToastContext';
import { getApiUrl } from '../../utils/api';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '38px',
    borderColor: state.isFocused ? '#4CAF50' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(76, 175, 80, 0.1)' : 'none',
    '&:hover': { borderColor: '#4CAF50' }
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#4CAF50' : state.isFocused ? '#E8F5E9' : 'white',
    color: state.isSelected ? 'white' : '#333',
    fontSize: '13px'
  }),
  menu: (base) => ({ ...base, zIndex: 9999 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  placeholder: (base) => ({ ...base, fontSize: '13px' }),
  singleValue: (base) => ({ ...base, fontSize: '13px' })
};

const PreparadoIngredientesModal = ({ isOpen, onClose, preparado }) => {
  const [items, setItems] = useState([]);
  const [ingredientes, setIngredientes] = useState([]);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [cantidadNueva, setCantidadNueva] = useState('');
  const [loading, setLoading] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const cantidadRef = useRef(null);
  const toast = useToast();

  useEffect(() => {
    if (isOpen && preparado) {
      cargarDatos();
    }
    if (!isOpen) {
      setItems([]);
      setItemSeleccionado(null);
      setCantidadNueva('');
    }
  }, [isOpen, preparado]);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [resItems, resIngredientes] = await Promise.all([
        fetch(getApiUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tipo: 'getIngredientesPreparado', idPreparado: preparado.idPreparado })
        }),
        fetch(getApiUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tipo: 'getIngredientes' })
        })
      ]);

      const dataItems = await resItems.json();
      const dataIngredientes = await resIngredientes.json();

      if (dataItems.success) {
        setItems(dataItems.data || []);
      }
      if (dataIngredientes.success) {
        setIngredientes(dataIngredientes.data || []);
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
      toast.error('Error al cargar ingredientes del preparado');
    } finally {
      setLoading(false);
    }
  };

  const opcionesSelect = ingredientes.map(i => ({ value: i.idIngrediente, label: i.nombre }));

  const agregarItem = () => {
    if (!itemSeleccionado) {
      toast.error('Seleccione un ingrediente');
      return;
    }
    const cantidad = parseFloat(cantidadNueva);
    if (!cantidad || cantidad <= 0) {
      toast.error('La cantidad debe ser mayor a 0');
      return;
    }

    // Si ya existe, sumar la cantidad
    const idBuscado = Number(itemSeleccionado.value);
    const indexExistente = items.findIndex(item => Number(item.idIngrediente) === idBuscado);

    if (indexExistente >= 0) {
      setItems(prev => prev.map((item, i) =>
        i === indexExistente ? { ...item, cantidad: item.cantidad + cantidad } : item
      ));
    } else {
      const nuevoItem = {
        idIngrediente: itemSeleccionado.value,
        cantidad: cantidad,
        nombre: itemSeleccionado.label
      };
      setItems(prev => [...prev, nuevoItem]);
    }
    setItemSeleccionado(null);
    setCantidadNueva('');
  };

  const eliminarItem = (index) => {
    setItems(prev => prev.filter((_, i) => i !== index));
  };

  const actualizarCantidad = (index, nuevaCantidad) => {
    const valor = parseFloat(nuevaCantidad);
    if (isNaN(valor)) return;
    setItems(prev => prev.map((item, i) =>
      i === index ? { ...item, cantidad: valor } : item
    ));
  };

  const guardarIngredientes = async () => {
    try {
      setGuardando(true);

      const itemsParaGuardar = items.map(item => ({
        idIngrediente: item.idIngrediente,
        cantidad: item.cantidad
      }));

      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'guardarIngredientesPreparado',
          idPreparado: preparado.idPreparado,
          items: itemsParaGuardar
        })
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Ingredientes guardados correctamente');
        onClose();
      } else {
        toast.error(data.message || 'Error al guardar ingredientes');
      }
    } catch (error) {
      console.error('Error al guardar ingredientes:', error);
      toast.error('Error al guardar ingredientes');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Ingredientes: ${preparado?.nombre || ''}`}
      onSave={guardarIngredientes}
      saveLabel="Guardar Ingredientes"
      isSaving={guardando}
      size="large"
      saveIcon={<FaSave />}
    >
      {loading ? (
        <div className="prep-ing-loading">Cargando ingredientes...</div>
      ) : (
        <>
          {/* Seccion agregar item */}
          <div className="prep-ing-agregar-row">
            <div className="prep-ing-select-container">
              <Select
                value={itemSeleccionado}
                onChange={(option) => { setItemSeleccionado(option); if (option) cantidadRef.current?.focus(); }}
                options={opcionesSelect}
                placeholder="Buscar ingrediente..."
                isSearchable={true}
                isClearable={true}
                noOptionsMessage={() => "Sin resultados"}
                styles={selectStyles}
                menuPortalTarget={document.body}
              />
            </div>

            <input
              ref={cantidadRef}
              type="number"
              className="prep-ing-cantidad-input"
              placeholder="Cantidad"
              value={cantidadNueva}
              onChange={(e) => setCantidadNueva(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); agregarItem(); } }}
              step="0.001"
              min="0"
            />

            <button
              type="button"
              className="prep-ing-btn-agregar"
              onClick={agregarItem}
              disabled={!itemSeleccionado || !cantidadNueva}
            >
              <FaPlus /> Agregar
            </button>
          </div>

          {/* Tabla de items */}
          <div className="prep-ing-tabla-container">
            {items.length === 0 ? (
              <div className="prep-ing-sin-items">No hay ingredientes en este preparado. Agregue ingredientes arriba.</div>
            ) : (
              <table className="prep-ing-tabla">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Cantidad</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={`${item.idIngrediente}-${index}`}>
                      <td>{item.nombre}</td>
                      <td>
                        <input
                          type="number"
                          className="prep-ing-cantidad-inline"
                          value={item.cantidad}
                          onChange={(e) => actualizarCantidad(index, e.target.value)}
                          step="0.001"
                          min="0"
                        />
                      </td>
                      <td>
                        <button
                          type="button"
                          className="prep-ing-btn-eliminar"
                          onClick={() => eliminarItem(index)}
                          title="Eliminar ingrediente"
                        >
                          <FaTrashAlt />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </FormModal>
  );
};

export default PreparadoIngredientesModal;
